import { Button, Card } from 'react-bootstrap';
import Timer from 'react-compound-timer';
import { Link } from 'react-router-dom';
import React from 'react';
import { ROUTES } from '../../../profileInfo/constant/Routes';

const CardHeader = ({ confirmed, history, translate, prevStep }) => (
  <Card.Header className='rtl'>
    <div className='login-options d-flex justify-content-between align-items-center'>
      <div className='d-flex justify-content-center my-2'>
        <Timer
          initialTime={60 * 1000}
          direction='backward'
          checkpoints={[
            {
              time: 1000,
              callback: () => {
                if (!confirmed) {
                  prevStep();
                }
              },
            },
          ]}
        >
          {() => (
            <>
              <Timer.Seconds />
              {translate('time_to_end_confirm')}
            </>
          )}
        </Timer>
      </div>
      <Button onClick={() => prevStep()} className='c-font-md  align-self-left' style={{ lineHeight: '18px' }}>
        {translate('back')}
      </Button>
    </div>
  </Card.Header>
);

export default CardHeader;
